export const errorLocation = '/something-went-wrong'
export const pageNotFoundLocation = '/page-not-found'
